export default __webpack_public_path__ + "static/media/virtual.315d8a75.svg";